import{createContext as t}from"../utils/context";export const[NavbarCollapseProvider,useNavbarCollapseContext]=t({strict:!1,name:"NavbarCollapseContext"});